import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { JOB_APPLICATION_STATUS } from 'shared/constants';
import styles from './Status.module.scss';

const getStatusClasses = (statusId) => {
  switch (statusId) {
    case JOB_APPLICATION_STATUS.INITIAL:
      return [styles.grey, 'la la-envelope'];
    case JOB_APPLICATION_STATUS.READ:
      return [styles.blue, 'la la-envelope-open-text'];
    case JOB_APPLICATION_STATUS.REVIEW:
      return [styles.yellow, 'la la-eye'];
    case JOB_APPLICATION_STATUS.INTERVIEW:
      return [styles.yellow, 'la la-user-friends'];
    case JOB_APPLICATION_STATUS.DECISION:
      return [styles.orange, 'la la-question-circle'];
    case JOB_APPLICATION_STATUS.OFFER:
      return [styles.green, 'la la-thumbs-up'];
    case JOB_APPLICATION_STATUS.HIRED:
      return [styles.green, 'la la-check-circle'];
    case JOB_APPLICATION_STATUS.CANCELED:
      return [styles.red, 'la la-user-times'];
    case JOB_APPLICATION_STATUS.REJECTED:
      return [styles.red, 'la la-times-circle'];
    default:
      return [styles.green, 'la la-user-clock'];
  }
};

const JobApplicationStatus = ({ statusId, className }) => {
  const { t } = useTranslation('common');
  const [statusClass, iconClass] = getStatusClasses(statusId);
  return (
    <span className={`${styles.status} ${statusClass} ${className}`}>
      <i className={iconClass} /> {t(`jaStatus.${statusId}`)}
    </span>
  );
};

JobApplicationStatus.propTypes = {
  statusId: PropTypes.string,
  className: PropTypes.string
};

JobApplicationStatus.defaultProps = {
  statusId: 'sent',
  className: ''
};

export default JobApplicationStatus;
